import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { isAuth } from 'src/app/auth-gurd/auth.service';
import { LandingPageComponent } from 'src/app/features-modules/public/landing-page/landing-page.component';
import { LandingPageModule } from 'src/app/features-modules/public/landing-page/landing-page.module';
import { AmbulanceComponent } from 'src/app/features-modules/public/others/ambulance/ambulance.component';
import { BloodDonationComponent } from 'src/app/features-modules/public/others/blood-donation/blood-donation.component';
import { EquipmentsComponent } from 'src/app/features-modules/public/others/equipments/equipments.component';
import { MedicineComponent } from 'src/app/features-modules/public/others/medicine/medicine.component';
import { profilerResolver } from 'src/app/shared/utils/doctor-profile-resolver.service';
import { FooterModule } from '../../header-footer/footer/footer.module';
import { HeaderModule } from '../../header-footer/header/header.module';
import { DoctorLayoutComponent } from '../doctor-layout/doctor-layout.component';
import { HospitalsComponent } from './../../../features-modules/public/others/hospitals/hospitals.component';
import { PublicLayoutComponent } from './public-layout.component';

const routes: Route[] = [
  {
    path: '',

    children: [
      {
        path: '',
        pathMatch: 'full',
        component: LandingPageComponent,
        data: { breadcrumb: 'Home' },
        // loadChildren: () =>
        //   import(
        //     '../../../features-modules/public/landing-page/landing-page.module'
        //   ).then((m) => m.LandingPageModule),
      },
      {
        path: 'search',
        component: PublicLayoutComponent,

        children: [
          {
            path: '',

            loadChildren: () =>
              import(
                '../../../features-modules/public/search-page/search-page.module'
              ).then((m) => m.SearchPageModule),
          },
          // {
          //   path: 'doctors/:id',
          //   loadChildren: () =>
          //     import(
          //       '../../../features-modules/public/doctor-profile-page/doctor-profile-page.module'
          //     ).then((m) => m.DoctorProfilePageModule),
          // },
          {
            path: 'doctors/:id',
            loadChildren: () =>
              import(
                '../../../features-modules/public/doctor-profile-page/doctor-profile-page.module'
              ).then((m) => m.DoctorProfilePageModule),
            resolve: { profilerResolver: profilerResolver },
          },
          // {
          //   path: 'doctors/:id/booking/:id',
          //   loadChildren: () =>
          //     import(
          //       '../features-modules/public/doctor-booking-page/doctor-booking-page.module'
          //     ).then((m) => m.DoctorBookingPageModule),
          // },
        ],
      },

      {
        path: 'agent',
        component: DoctorLayoutComponent,
        canActivate: [isAuth],
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../../../features-modules/agent/agent.module').then(
                (m) => m.AgentModule
              ),
          },
        ],
      },
      {
        path: 'doctor',
        canActivate: [isAuth],
        data: { breadcrumb: 'Doctor' },
        component: DoctorLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../../../features-modules/doctor/doctor.module').then(
                (m) => m.DoctorModule
              ),
          },
        ],
      },
      {
        path: 'patient',
        canActivate: [isAuth],
        component: DoctorLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../../../features-modules/patient/patient.module').then(
                (m) => m.PatientModule
              ),
          },
        ],
      },
      {
        path: 'soowgood-point',
        data: { breadcrumb: 'Soowgood point' },
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../features-modules/public/soowgood-point/soowgood-point.module'
              ).then((m) => m.SoowgoodPointModule),
          },
        ],
      },
      {
        path: 'soowgood-booth',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../features-modules/public/soowgood-booth/soowgood-booth.module'
              ).then((m) => m.SoowgoodBoothModule),
          },
        ],
      },
      {
        path: 'about-us',
        data: { breadcrumb: 'About us' },
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../features-modules/public/about-us/about-us.module'
              ).then((m) => m.AboutUsModule),
          },
        ],
      },
      {
        path: 'ambulance',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            component: AmbulanceComponent,
          },
        ],
      },
      {
        path: 'equipments',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            component: EquipmentsComponent,
          },
        ],
      },
      {
        path: 'blood-donation',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            component: BloodDonationComponent,
          },
        ],
      },
      {
        path: 'hospitals',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            component: HospitalsComponent,
          },
        ],
      },
      {
        path: 'medicine',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            component: MedicineComponent,
          },
        ],
      },

      {
        path: 'contact-us',
        data: { breadcrumb: 'Contact us' },
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../features-modules/public/contact-us/contact-us.module'
              ).then((m) => m.ContactUsModule),
          },
        ],
      },
      {
        path: 'terms-services',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../features-modules/public/tearms-services/tearms-services.module'
              ).then((m) => m.TearmsServicesModule),
          },
        ],
      },
      {
        path: 'refund-policy',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../features-modules/public/refund-policy/refund-policy.module'
              ).then((m) => m.RefundPolicyModule),
          },
        ],
      },
      {
        path: 'privacy',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../features-modules/public/privacy/privacy.module'
              ).then((m) => m.PrivacyModule),
          },
        ],
      },
      // TODO
      {
        path: 'complete-profile',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../core-modules/auth/complete-profile/complete-profile.module'
              ).then((m) => m.CompleteProfileModule),
          },
        ],
      },
      {
        path: 'complete-profile',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../core-modules/auth/complete-profile/complete-profile.module'
              ).then((m) => m.CompleteProfileModule),
          },
        ],
      },

      {
        path: 'agent-home',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../features-modules/public/agent-home/agent-home.module'
              ).then((m) => m.AgentHomeModule),
          },
        ],
      },

      {
        path: 'video-consultation',
        loadChildren: () =>
          import('../../../shared/modules/agora-video/agora-video.module').then(
            (m) => m.AgoraVideoModule
          ),
      },
      //
      {
        path: 'health-plan',
        component: PublicLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                '../../../features-modules/public/health-plan/health-plan.module'
              ).then((m) => m.HealthPlanModule),
          },
          {
            path: ':slug',
            loadChildren: () =>
              import(
                '../../../features-modules/public/health-plan-details/plan-details.module'
              ).then((m) => m.HealthPlanDetailsModule),
          },
        ],
      },
    ],
  },
];

@NgModule({
  declarations: [PublicLayoutComponent, DoctorLayoutComponent],
  imports: [
    CommonModule,
    HeaderModule,
    RouterModule.forChild(routes),
    LandingPageModule,
    FooterModule,
  ],
  exports: [PublicLayoutComponent],
})
export class PublicLayoutModule {}
